import { RouterConst } from './router.consts';

export class NavigationPathFunctions {
  static navigateToSignIn(): string {
    return `/${RouterConst.AUTHENTICATION.PATH}/${RouterConst.AUTHENTICATION.CHILDREN.SIGN_IN.PATH}`;
  }

  static navigateToResetPassword(): string {
    return `/${RouterConst.AUTHENTICATION.PATH}/${RouterConst.AUTHENTICATION.CHILDREN.RESET_PASSWORD.PATH}`;
  }

  static navigateToDashboard(): string {
    return `/${RouterConst.DASHBOARD.PATH}/${RouterConst.DASHBOARD.CHILDREN.OVERVIEW.PATH}`;
  }

  static navigateToTestsList(): string {
    return `/${RouterConst.DASHBOARD.PATH}/${RouterConst.DASHBOARD.CHILDREN.TEST.PATH}/${RouterConst.DASHBOARD.CHILDREN.TEST.CHILDREN.LIST.PATH}`;
  }

  static navigateToCreateTest(): string {
    return `/${RouterConst.DASHBOARD.PATH}/${RouterConst.DASHBOARD.CHILDREN.TEST.PATH}/${RouterConst.DASHBOARD.CHILDREN.TEST.CHILDREN.CREATE.PATH}`;
  }

  static navigateToEditTest(testUuid: string): string {
    return `/${RouterConst.DASHBOARD.PATH}/${RouterConst.DASHBOARD.CHILDREN.TEST.PATH}/${RouterConst.DASHBOARD.CHILDREN.TEST.CHILDREN.EDIT(testUuid).PATH}`;
  }

  static navigateToOrganizationsList(): string {
    return `/${RouterConst.DASHBOARD.PATH}/${RouterConst.DASHBOARD.CHILDREN.ORGANIZATION.PATH}/${RouterConst.DASHBOARD.CHILDREN.ORGANIZATION.CHILDREN.LIST.PATH}`;
  }

  static navigateToCreateOrganization(): string {
    return `/${RouterConst.DASHBOARD.PATH}/${RouterConst.DASHBOARD.CHILDREN.ORGANIZATION.PATH}/${RouterConst.DASHBOARD.CHILDREN.ORGANIZATION.CHILDREN.CREATE.PATH}`;
  }

  static navigateToOrganizationDetails(organizationUuid: string): string {
    return `/${RouterConst.DASHBOARD.PATH}/${RouterConst.DASHBOARD.CHILDREN.ORGANIZATION.PATH}/${RouterConst.DASHBOARD.CHILDREN.ORGANIZATION.CHILDREN.DETAILS(organizationUuid).PATH}`;
  }

  static navigateToDimensionsList(): string {
    return `/${RouterConst.DASHBOARD.PATH}/${RouterConst.DASHBOARD.CHILDREN.DIMENSION.PATH}/${RouterConst.DASHBOARD.CHILDREN.DIMENSION.CHILDREN.LIST.PATH}`;
  }

  static navigateToCreateDimension(): string {
    return `/${RouterConst.DASHBOARD.PATH}/${RouterConst.DASHBOARD.CHILDREN.DIMENSION.PATH}/${RouterConst.DASHBOARD.CHILDREN.DIMENSION.CHILDREN.CREATE.PATH}`;
  }

  static navigateToEditDimension(dimensionUuid: string): string {
    return `/${RouterConst.DASHBOARD.PATH}/${RouterConst.DASHBOARD.CHILDREN.DIMENSION.PATH}/${RouterConst.DASHBOARD.CHILDREN.DIMENSION.CHILDREN.EDIT(dimensionUuid).PATH}`;
  }
}
